import dayjs from "dayjs";
const basePath = sessionStorage.getItem('APP_BASE_PATH')
const columns = [
  {
    title: "Employee ID",
    dataIndex: "uid",
    render: (text, record) => (
      <a
        href={`${basePath}/ViewPage/${record.uid}`}
        rel="noopener noreferrer"
        style={{ textDecoration: "underline", color: "blue" }}
      >
        {text}
      </a>
    ),
    width: "15%",
  },
  {
    title: "Employee Name",
    dataIndex: "firstName",
    render: (text, record) => `${record.firstName} ${record.lastName}`,
    width: "25%",
  },
  {
    title: "Onboarding Date",
    dataIndex: "onBoardingDate",
    render: (date) => (date ? date : "-"),
    width: "20%",
    className: "text-center",
  },
  {
    title: "Location",
    dataIndex: "baseLocation"
  },
  {
    title: "Status",
    dataIndex: "status"
  },
];

export default columns;
